import {
  faArrowAltCircleLeft,
  faArrows,
  faBalanceScale,
  faBarChart,
  faBriefcase,
  faBuilding,
  faCamera,
  faChartArea,
  faCompass,
  faDiagramProject,
  faEnvelope,
  faFax,
  faFile,
  faGlasses,
  faHomeUser,
  faHouse,
  faLocationPinLock,
  faMap,
  faMoneyBill1,
  faPrint,
  faRoad,
  faSearch,
  faTable,
  faTableCells,
  faTableColumns,
  faTableList,
  faTimes,
  faUser,
  faUserCircle,
  faUserClock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { TSLandingPage } from "../components/TSLandingPage";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { FullScreenPerformanceMetrics } from "../pages/demos/chm/FullScreenPerformanceMetrics";
import { HeatmapPerformanceMetrics } from "../pages/demos/chm/HeatmapPerformanceMetrics";
import { TablePerformanceMetrics } from "../pages/demos/chm/TablePerformanceMetrics";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import {
  SubdomainOrgIdObject,
  subMenuDefaultProps,
} from "./FunctionsAndInterfaces";

const orgId: number = 74610152;
const subDomain: string = "cambio";
const nameOfProduct: string = "Cambio";
const secureRouteGroups: string[] = ["CHM"];

export const chmObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  externalInfo: { subdomain: "chm", productURL: "chm" },
};

const sidebarMenu = () => {
  return (
    <>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Cambio"}
        icon={<FontAwesomeIcon className="me-2" icon={faUser} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faHouse} />
              Homepage
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboards&fromMenu=true`}
            state={{ isLiveboard: false, link: "pinboards/" }}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faChartArea} />
              Liveboards
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/contactus`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faEnvelope} />
              Contact Us
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/signout`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
              Log Out
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Search"}
        icon={<FontAwesomeIcon className="me-2" icon={faLocationPinLock} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/product?productURL=answer&fromMenu=true`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faSearch} />
              Search
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Liveboards"}
        icon={<FontAwesomeIcon className="me-2" icon={faDiagramProject} />}
      >
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/858d8b5b-3db8-4a5f-bcea-cdf06c05cca0&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faUserCircle} />
              Retail Channel Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/67eba66c-e1f6-4b3e-990d-0c624873b1e3&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faUserClock} />
              Retail Channel Summary v2
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/afd42ebe-656c-4796-832f-4a68b2d5bc28&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faRoad} />
              Wholesale Channel Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/373e550b-85b2-4531-9f12-938e069efbdd&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTimes} />
              Lock Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/4d398d38-0467-4e18-8e38-8ee170fbfa8e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faHomeUser} />
              Lock Report Month to Date
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/dfe579f9-cfb0-4371-95a0-b1ec3568939b&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFax} />
              Daily Average Volume by Month
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/04949638-d30c-4528-9167-e7dc94a0040a&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBriefcase} />
              Daily Lock Report
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Scoreboards"}
        icon={<FontAwesomeIcon className="me-2" icon={faChartArea} />}
      >
        <MenuItem>
          <Link to={`/${subDomain}/aeperformancesummary`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faMap} />
              AE Performance Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/aescoreboard`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTableColumns} />
              AE Performance Scoreboard
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/5b856bf6-e181-4854-81bf-d3ae60362070&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTable} />
              Wholesale Ranking
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/wholesalesale`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTableColumns} />
              Wholesale Executive Dashboard
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/retail`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTableColumns} />
              Retail Executive Dashboard
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/branchesperformancesummary`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faCompass} />
              Branches Performance Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/branchesscoreboard`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTableCells} />
              Branches Performance Scoreboard
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/loperformancesummary`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faDiagramProject} />
              LO Performance Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to={`/${subDomain}/loscoreboard`}>
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faTableList} />
              LO Performance Scoreboard
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
      <SubMenu
        {...subMenuDefaultProps}
        title={"Other"}
        icon={<FontAwesomeIcon className="me-2" icon={faArrows} />}
      >
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/cef8c0f9-9398-49c8-a0ea-e65edffbfb59&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faPrint} />
              Pipeline Overview
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/916c0c86-21f8-4287-8876-09586ce68297&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faUserCircle} />
              Originations Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b06a5cce-2347-4e93-bf8f-c3fbb2319aa2&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faGlasses} />
              AE Summary
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/e7219ea4-c11e-472b-a072-aafef848ab64&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faCamera} />
              Originations Snapshot
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/c08ef7be-fffe-4f9f-9ba2-712ce22c1e68&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFile} />
              Retail Region
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/963ac30c-233f-4a6b-84ab-6fa63f76d83a&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBuilding} />
              Retail Branch
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/803e939d-6381-45ae-90f6-6706ac66cd9a&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBriefcase} />
              Retail LO
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/6cf561fd-d685-44cc-b20d-f718903e091e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faFile} />
              Wholesale Region
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/39bd4c30-2495-4581-9d3a-9de4138bb6a6&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBarChart} />
              Wholesale AE
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b831d1cb-26f9-42c6-b2c2-6102be2f2ba8&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faBalanceScale} />
              Wholesale Broker
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            to={`/${subDomain}/product?productURL=pinboard/b53cb3b0-f03d-4d08-b145-6259aae5279e&fromMenu=true`}
          >
            <div className="sidebar-item">
              <FontAwesomeIcon className="me-2" icon={faMoneyBill1} />
              Fulfillment Productivity
            </div>
          </Link>
        </MenuItem>
      </SubMenu>
    </>
  );
};

export const CambioLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        { title: "Search", description: "", link: "answer" },
        { title: "Liveboards", description: "", link: "pinboards/" },
        {
          title: "Other Liveboards",
          description: "",
          link: `/${subDomain}/other`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Retail Channel Summary",
          description: "",
          link: "pinboard/858d8b5b-3db8-4a5f-bcea-cdf06c05cca0",
        },
        {
          title: "Retail Channel Summary v2",
          description: "",
          link: "pinboard/67eba66c-e1f6-4b3e-990d-0c624873b1e3",
        },
        {
          title: "Branch Performance Summary",
          description: "",
          link: `/${subDomain}/branchesperformancesummary`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Branch Performance Scoreboard",
          description: "",
          link: `/${subDomain}/branchesscoreboard`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "LO Performance Summary",
          description: "",
          link: `/${subDomain}/loperformancesummary`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "LO Performance Scoreboard",
          description: "",
          link: `/${subDomain}/loscoreboard`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Wholesale Ranking",
          description: "",
          link: "pinboard/5b856bf6-e181-4854-81bf-d3ae60362070",
        },
        {
          title: "Wholesale Channel Summary",
          description: "",
          link: "pinboard/afd42ebe-656c-4796-832f-4a68b2d5bc28",
        },
        {
          title: "AE Performance Summary",
          description: "",
          link: `/${subDomain}/aeperformancesummary`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "AE Performance Scoreboard",
          description: "",
          link: `/${subDomain}/aescoreboard`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Wholesale Executive Dashboard",
          description: "",
          link: `/${subDomain}/wholesalesale`,
          internal: true,
          overrideParentURL: true,
        },
        {
          title: "Retail Executive Dashboard",
          description: "",
          link: `/${subDomain}/retail`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Lock Summary",
          description: "",
          link: "pinboard/373e550b-85b2-4531-9f12-938e069efbdd",
        },
        {
          title: "Lock Report Month to Date",
          description: "",
          link: "pinboard/4d398d38-0467-4e18-8e38-8ee170fbfa8e",
        },
        {
          title: "Daily Average Volume by Month",
          description: "",
          link: "pinboard/dfe579f9-cfb0-4371-95a0-b1ec3568939b",
        },
        {
          title: "Daily Lock Report",
          description: "",
          link: "pinboard/04949638-d30c-4528-9167-e7dc94a0040a",
        },
      ],
    ]}
  />
);

export const CambioOtherLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomain}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Retail Region",
          description: "",
          link: "pinboard/c08ef7be-fffe-4f9f-9ba2-712ce22c1e68",
        },
        {
          title: "Retail Branch",
          description: "",
          link: "pinboard/963ac30c-233f-4a6b-84ab-6fa63f76d83a",
        },
        {
          title: "Retail LO",
          description: "",
          link: "pinboard/803e939d-6381-45ae-90f6-6706ac66cd9a",
        },
      ],
      [
        {
          title: "Originations Snapshot",
          description: "",
          link: "pinboard/e7219ea4-c11e-472b-a072-aafef848ab64",
        },
        {
          title: "Fulfillment Productivity",
          description: "",
          link: "pinboard/b53cb3b0-f03d-4d08-b145-6259aae5279e",
        },
      ],
      [
        {
          title: "Wholesale Region",
          description: "",
          link: "pinboard/6cf561fd-d685-44cc-b20d-f718903e091e",
        },
        {
          title: "Wholesale AE",
          description: "",
          link: "pinboard/39bd4c30-2495-4581-9d3a-9de4138bb6a6",
        },
        {
          title: "Wholesale Broker",
          description: "",
          link: "pinboard/b831d1cb-26f9-42c6-b2c2-6102be2f2ba8",
        },
      ],
      [
        {
          title: "Pipeline Overview",
          description: "",
          link: "pinboard/cef8c0f9-9398-49c8-a0ea-e65edffbfb59",
        },
        {
          title: "Originations Summary",
          description: "",
          link: "pinboard/916c0c86-21f8-4287-8876-09586ce68297",
        },
      ],
    ]}
  />
);
export const chmRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={CambioLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/other`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={CambioOtherLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              orgObject={chmObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}product`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/aeperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Account Executive" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/aescoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics
              addTotalsToCSV={true}
              scope="Account Executive"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/branchesperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Branches" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/branchesscoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics addTotalsToCSV={true} scope="Branches" />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/loperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Loan Officers" />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/loscoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics
              addTotalsToCSV={true}
              scope="Loan Officers"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/wholesalesale`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <FullScreenPerformanceMetrics
              scope="Wholesale"
              overrideTitle="Wholesale Executive Dashboard"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/retail`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <FullScreenPerformanceMetrics
              scope="Retail"
              overrideTitle="Retail Executive Dashboard"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
